module.exports = __webpack_public_path__ + "static/media/camel_w_1440.ae84b48b.jpg";